(ns frontend.view.modals.curtains.merge-option-curtain.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ui.component.text.view :refer [text]]
   [frontend.view.modals.curtains.merge-option-curtain.events :as events]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]))

(defonce modal-key :curtain/merge-option)

(defn processing
  [data-state]
  [:div
   {:class (uu/cm "p-8 relative hidden left-0 right-0 bottom-0 top-0" (when (:processing? @data-state) "flex justify-center items-center"))}
   [:div
    {:class "flex flex-col gap-3"}
    [:i.fal.fa-spinner.fa-pulse.fa-4x]
    [:span (loc/tr :processing)]]])

(defn view
  [{:keys [_shown? _topmost? _close-modal! _props _state]}]
  (let [local-state (r/atom {})]
    (fn [{:keys [shown? topmost? close-modal! props state]}]
      (let [{:keys [header-text
                    victim-id
                    targets
                    pipelines
                    named-value
                    on-completed!]}
            props
            header-text (or header-text (loc/tr :merge-option))
            all-selected? (->> pipelines
                               (map :db/id)
                               (every? (fn [pipeline-id]
                                         (get @local-state pipeline-id))))
            processing? (:processing? @state)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         header-text
         [:<>
          (if processing?
            [processing state]
            [:<>
             [alert/warning
              {}
              [:span
               [:span (loc/tr :merge-options-modal-info)] [:br]
               (when (seq pipelines)
                 [:<> [text (loc/tr :merge-options-modal-info-per-pipeline)] [:br]])
               [:span (loc/tr :merge-options-modal-secondary-info [(:named-value/value named-value)])]]]
             [:div
              {:class "mt-3"}
              (if (empty? pipelines)
                (let [target-id (:target-id @local-state)
                      options (->> targets
                                   (map (fn [target]
                                          {:value (:db/id target)
                                           :label (:named-value/value target)})))]
                  [labelled-input/view
                   {:editor-type :editor.type/select
                    :options     options
                    :label       (loc/tr :merge-with [(:named-value/value named-value)])
                    :value       (->> options
                                      (cu/filter-by :value target-id)
                                      (first))
                    :on-change   (fn [new-value]
                                   (swap! local-state assoc :target-id new-value))}])
                (doall
                 (for [pipeline pipelines
                       :let [{:keys [db/id]} pipeline
                             pipeline-name (:pipeline/name pipeline)
                             merge-value (get @local-state id)
                             options (->> targets
                                          (map (fn [target]
                                                 {:value (:db/id target)
                                                  :label (:named-value/value target)})))]]
                   ^{:key (str "merge-target-" id)}
                   [:div
                    [labelled-input/view
                     {:editor-type :editor.type/select
                      :options     options
                      :label       pipeline-name
                      :value       (->> options
                                        (cu/filter-by :value merge-value)
                                        (first))
                      :on-change   (fn [new-value]
                                     (swap! local-state assoc id new-value))}] ()])))]])]
         (when-not processing?
           [:<>
            [modal/left-cancel-only close-modal! nil]
            [modal/right-single-button
             nil
             (if (empty? pipelines)
               (not (:target-id @local-state))
               (not all-selected?))
             #(events/merge! pipelines local-state victim-id state close-modal! on-completed!)
             (loc/tr :apply)
             nil]])]))))
